export const CURRENCY = "EUR";

interface OrganizationDetails {
  id: string;
  title: string;
  websiteTitle?: string;
  phoneNumber: string;
  emailAddress: string;
  address: string;
  brandColor: {
    main: string;
    alpha: string;
    darken: string;
  };
  favicon?: {
    icon96: string;
    iconSvg: string;
    iconShortcut: string;
    iconAppleTouch: string;
    appleMobileWebAppTitle: string;
    siteManifest: string;
  };
}

export const ORGANIZATION_SETTIGS_BY_ALIAS: Record<
  string,
  OrganizationDetails
> = {
  anima: {
    id: "6507f3d5-ba4e-44f9-b0d0-33e7ab5810d1",
    title: "Kūno priežiūros studija - ANIMA",
    websiteTitle: "ANIMA - kūno priežiūra",
    phoneNumber: "+37068390851",
    emailAddress: "masazasvakuuminis@gmail.com",
    address: "Vytauto pr. 13, Kaunas",
    // Alternative colors...
    // brandColor: {
    //   main: "#b84781",
    //   alpha: "#b8478180",
    //   darken: "#95406b",
    // },
    brandColor: {
      main: "#3b4f6a",
      alpha: "#3b4f6a80",
      darken: "#2e3e54",
    },
    favicon: {
      icon96: "/anima/favicon-96x96.png",
      iconSvg: "/anima/favicon.svg",
      iconShortcut: "/anima/favicon.ico",
      iconAppleTouch: "/anima/apple-touch-icon.png",
      appleMobileWebAppTitle: "Anima",
      siteManifest: "/anima/site.webmanifest",
    },
  },
  pavyzdys: {
    id: "22405289-acf2-4236-8597-ef68e8cdfd22",
    title: "Pavyzdinė rezervacijos sistema",
    phoneNumber: "+37060000000",
    emailAddress: "info@takeblock.com",
    address: "Debesų technologijų pr. 123, Kaunas",
    brandColor: {
      main: "#5e5e5e",
      alpha: "#5e5e5e80",
      darken: "#4a4a4a",
    },
  },
};
